import React from "react";

interface ImmigramFormBoundaryProps {
  name: string;
  children: React.ReactNode;
}

export class ImmigramFormBoundary extends React.Component<
  ImmigramFormBoundaryProps,
  { hasError: boolean }
> {
  constructor(props: ImmigramFormBoundaryProps) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="relative rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700"
          role="alert"
        >
          <strong className="font-bold">
            Failed to render {this.props.name}
          </strong>
        </div>
      );
    }

    return this.props.children;
  }
}
